<template>
  <parent>
    <div class="distribution-wrapper">
      <paper
        v-if="!loading"
        class="mt-2 pb-2"
      >
        <template v-slot:title>
          <p class="mb-0">
            Info
          </p>
        </template>
        <div class="col-lg-12 d-flex flex-wrap">
          <input-field
            label="Distribution ID"
            label-position="top"
            class="font-weight-bold col-sm-6 col-lg-3"
          >
            <a
              v-clipboard:copy="distribution.distributionId"
              v-clipboard:success="copySuccess"
            >
              {{ distribution.distributionId || '-' }}
              <GjIcon
                name="Copy"
                size="20"
              />
            </a>
          </input-field>
          <input-field
            label="Domain Name"
            label-position="top"
            class="font-weight-bold col-sm-6 col-lg-3"
          >
            <a
              v-clipboard:copy="distribution.domainName"
              v-clipboard:success="copySuccess"
            >
              {{ distribution.domainName || '-' }}
              <GjIcon
                name="Copy"
                size="20"
              />
            </a>
          </input-field>
          <input-field
            label="Traffic"
            label-position="top"
            class="font-weight-bold col-sm-6 col-lg-3"
          >
            {{ formatBytes(totalBytes) || '-' }} in the last 24h
          </input-field>
          <input-field
            label="Last Modified"
            label-position="top"
            class="font-weight-bold col-sm-6 col-lg-3"
          >
            {{ formatOffsetDateTime(distribution.lastModified) || '-' }}
          </input-field>
        </div>
      </paper>

      <paper
        v-if="!loading"
        class="mt-2 pb-2"
      >
        <template v-slot:title>
          <p class="mb-0">
            Distribution Settings
          </p>
        </template>
        <div class="float-right mr-3">
          <b-button
            v-if="$can('update', 'distributions', 'cdn')"
            :disabled="loading"
            variant="bg-white"
            @click="$router.push({ name: 'settings-editor', params: { id } })"
          >
            <GjIcon
              name="Edit"
              class="icon-left"
            />
            Edit
          </b-button>
        </div>
        <div class="col-lg-10 d-flex flex-wrap">
          <input-field
            label="State"
            label-position="top"
            class="font-weight-bold col-sm-6 col-lg-4"
          >
            {{ distribution.state || '-' }}
          </input-field>
          <input-field
            label="Distribution Status"
            label-position="top"
            class="font-weight-bold col-sm-6 col-lg-4"
          >
            <DistributionStatus :type="findStatus(distribution.distributionStatusOptions)" /> {{
              findStatus(distribution.distributionStatusOptions) || '-' }}
          </input-field>
          <input-field
            label="Comment"
            label-position="top"
            class="font-weight-bold col-sm-6 col-lg-4"
          >
            {{ distribution.comment || '-' }}
          </input-field>
          <input-field
            label="WAF Settings"
            label-position="top"
            class="font-weight-bold col-sm-6 col-lg-4"
          >
            {{ getText(distribution.wafSettingOptions, distribution.wafSetting) }}
          </input-field>
          <input-field
            label="Altername Domain Name"
            label-position="top"
            class="font-weight-bold col-sm-6 col-lg-4"
          >
            {{ distribution.alternateDomainNames || '-' }}
          </input-field>
          <input-field
            label="Default Root Object"
            label-position="top"
            class="font-weight-bold col-sm-6 col-lg-4"
          >
            {{ distribution.defaultRootObject || '-' }}
          </input-field>
          <input-field
            label="Image Optimizer"
            label-position="top"
            class="font-weight-bold col-sm-6 col-lg-4"
          >
            {{ distribution.imageOptimizer ? true : false }}
          </input-field>

          <input-field
            label="SSL Certificate"
            label-position="top"
            class="font-weight-bold col-sm-6 col-lg-4"
          >
            {{ distribution.sslCertificate || '-' }}
          </input-field>
          <input-field
            label="Last Modified"
            label-position="top"
            class="font-weight-bold col-sm-6 col-lg-4"
          >
            {{ formatOffsetDateTime(distribution.lastModified) || '-' }}
          </input-field>
        </div>
      </paper>
    </div>
  </parent>
</template>
<script>
import { useClipboard } from '@vueuse/core'
import Paper from '@/components/paper/Paper.vue'
import redirectError from '@/services/redirectError'
import DistributionStatus from './components/DistributionStatus.vue'

export default {
  name: 'General',
  components: { Paper, DistributionStatus },
  data() {
    return {
      totalBytes: null,
    }
  },
  computed: {
    distribution() {
      return this.$store.state.cdn.distribution
    },
    statusOptions() {
      return this.distribution.distributionStatusOptions
    },
    loading() {
      return this.$store.state.cdn.gettingDistribution
    },
  },
  created() {
    this.id = this.$route.params.id
    this.getDistribution(this.id)
    // this.getDistributionAnalytics()
  },
  methods: {
    findStatus() {
      for (let i = 0; i < this.statusOptions.length; i++) {
        if (
          this.statusOptions[i].id === this.distribution.distributionStatus
        ) {
          return this.statusOptions[i].value
        }
      }
      return '-'
    },
    getDistribution(id) {
      this.$store
        .dispatch('cdn/getDistribution', id)
        .catch(err => redirectError(err))
    },
    // getDistributionAnalytics() {
    //   const requestQueryObj = {
    //     interval: 0,
    //   }
    //   this.$store
    //     .dispatch('analytics/fetchAnalytics', requestQueryObj)
    //     .then(res => {
    //       this.totalBytes = res.data.result.totalBytes
    //     })
    //     .catch(err => redirectError(err))
    // },
    findSecurityPolicy() {
      for (let i = 0; i < this.securityPolicy.length; i++) {
        if (this.securityPolicy[i].id === this.distribution.securityPolicy) {
          return this.securityPolicy[i].value
        }
      }
      return '-'
    },
    onCopy(name) {
      const { copy } = useClipboard()
      copy(name)
      this.copySuccess()
    },
  },
}
</script>
